/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Rounds_Seating_UndoInputs */



/**
* | output |
* | --- |
* | "Undo last move ({count})" |
*
* @param {Rounds_Seating_UndoInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_seating_undo = /** @type {((inputs: Rounds_Seating_UndoInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Seating_UndoInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Annuler le dernier déplacement (${i?.count})`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Deshacer el último movimiento (${i?.count})`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Desfazer o último movimento (${i?.count})`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Annulla l'ultimo spostamento (${i?.count})`)
	return /** @type {LocalizedString} */ (`Undo last move (${i?.count})`)
});